import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ProductShowcase() {
  const tomos = [{
    id: 'T1',
    icon: '📘',
    title: 'Tomo 1 — Introducción a la Economía Agropecuaria',
    desc: 'Conceptos básicos aplicados al agro, factores productivos, sistemas rurales y lógica económica del campo.'
  }, {
    id: 'T2',
    icon: '📗',
    title: 'Tomo 2 — Costos y Producción Agropecuaria',
    desc: 'Costos fijos y variables, rentabilidad, punto de equilibrio, análisis real de producción agrícola y ganadera.'
  }, {
    id: 'T3',
    icon: '📙',
    title: 'Tomo 3 — Mercados Agropecuarios',
    desc: 'Oferta y demanda en el agro, precios, comercialización, mercado interno y exportaciones.'
  }, {
    id: 'T4',
    icon: '📕',
    title: 'Tomo 4 — Economía Argentina y el Agro',
    desc: 'Inflación, retenciones, exportaciones, rol del agro en la economía nacional.'
  }, {
    id: 'T5',
    icon: '📓',
    title: 'Tomo 5 — Gestión y Administración Rural',
    desc: 'Organización productiva, toma de decisiones, planificación agropecuaria.'
  }, {
    id: 'T6',
    icon: '📔',
    title: 'Tomo 6 — Proyectos Productivos Agropecuarios',
    desc: 'Diseño de proyectos, simulación de emprendimientos rurales y evaluación económica.'
  }];
  const includes = ['Explicaciones claras listas para enseñar', 'Ejemplos reales del agro argentino', 'Actividades listas para usar', 'Preguntas guía', 'Evaluaciones completas', 'Rúbricas y criterios de corrección', 'Secuencias didácticas listas', 'Adaptaciones para distintos niveles'];
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <div className="text-center mb-8" data-id="element-172">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-173">
            🏆 KIT COMPLETO ECONOMÍA AGROPECUARIA LISTA
          </h2>
          <p className="text-lg md:text-xl font-bold text-brand-accent neon-glow" data-id="element-174">
            6 Tomos + 4 Bonos — Todo resuelto
          </p>
          <p className="text-sm md:text-base text-gray-500 mt-1 font-medium" data-id="element-175">
            +400 páginas listas para usar en el aula
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-176">
          <h3 className="text-xl font-black text-white inline-flex items-center bg-brand-accent px-4 py-1.5 rounded-lg" data-id="element-177">
            🌾 6 TOMOS COMPLETOS
          </h3>
          <p className="text-sm md:text-base font-bold text-gray-500 mt-2" data-id="element-178">
            Economía real aplicada al campo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-179">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-dark border border-white/10 rounded-xl p-4 md:p-5 hover:border-brand-accent/30 transition-colors" data-id="element-180">
              <h4 className="text-lg font-bold text-white mb-2 flex items-start" data-id="element-181">
                <span className="text-xl mr-2 leading-none" data-id="element-182">{tomo.icon}</span>
                <span data-id="element-183">{tomo.title}</span>
              </h4>
              <p className="text-sm text-gray-400 leading-relaxed ml-7" data-id="element-184">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-dark rounded-xl border border-white/10 overflow-hidden" data-id="element-185">
          <div className="bg-brand-accent py-3 px-4 text-center" data-id="element-186">
            <h4 className="text-lg md:text-xl font-bold text-white" data-id="element-187">
              ✅ CADA TOMO INCLUYE:
            </h4>
          </div>
          <div className="p-4 md:p-6" data-id="element-188">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6" data-id="element-189">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-190">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent mr-2.5 shrink-0" data-id="element-191" />
                  <span className="text-sm text-gray-300 font-medium" data-id="element-192">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}